import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { usePipedriveStore } from "../..";
import { formatNumber, formatPrice } from "../../utils/utils";
import infoStyles from '../Info.module.css';

function LeaseCompInfo({ pipedriveCompanyId, address, totalRent, parcelSizeAcres, buildingSize, className, onClick }: ILeaseCompInfoProps) {
    const pipedriveStore = usePipedriveStore();
    const pipedriveOrganization = useMemo(() => computed(() => pipedriveStore.organizations.find(o => o.id === pipedriveCompanyId)), []).get();

    return (
        <div className={[infoStyles.container, className].join(" ")} onClick={onClick}>
            <div className={infoStyles.title}>{pipedriveOrganization?.name}</div>
            <div className={infoStyles.description}>{address}</div>

            <div className={infoStyles.description}>
                {[
                    !!totalRent && formatPrice(totalRent),
                    !!parcelSizeAcres && `${formatNumber(parcelSizeAcres)} Acres`,
                    !!buildingSize && `${formatNumber(buildingSize)} Sq-Ft`,
                ].filter(d => d).join(" - ")}
            </div>
        </div>
    );
}

export interface ILeaseCompInfoProps {
    pipedriveCompanyId: number | null;
    address: string;
    totalRent: number;
    parcelSizeAcres: number | null;
    buildingSize: number | null;
    className?: string;
    onClick?: () => void;
}

export default observer(LeaseCompInfo);